"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = tslib_1.__importDefault(require("./utils"));
function getRegion(node) {
    var offset;
    var w;
    var h;
    if (!utils_1.default.isWindow(node) && node.nodeType !== 9) {
        offset = utils_1.default.offset(node);
        w = utils_1.default.outerWidth(node);
        h = utils_1.default.outerHeight(node);
    }
    else {
        var win = utils_1.default.getWindow(node);
        offset = {
            left: utils_1.default.getWindowScrollLeft(win),
            top: utils_1.default.getWindowScrollTop(win),
        };
        w = utils_1.default.viewportWidth(win);
        h = utils_1.default.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
exports.default = getRegion;
//# sourceMappingURL=getRegion.js.map